/** The hospital briefing shown to players before and after a shift. Plain language, no rules numbers. */
export interface BriefingScreen {
  id: string;
  title: string;
  body: string[];
}

export const BRIEFING: BriefingScreen[] = [
  {
    id: 'night',
    title: 'The night',
    body: [
      'It is nine in the evening and the day team is heading home. For the next ten hours, this hospital is yours.',
      'The night is long, the corridors are quiet, and the phones will not stay that way for long.',
    ],
  },
  {
    id: 'front-door',
    title: 'The front door',
    body: [
      'Every patient comes in through the Emergency department. Some walk in with a sore ankle, and some arrive on a trolley with the doors held open.',
      'The Emergency doctor looks at each new arrival, decides what is wrong, and either treats them, sends them home, or passes them on.',
    ],
  },
  {
    id: 'wards',
    title: 'The wards',
    body: [
      'The Surgeon looks after the surgical ward, and the Physician looks after the medical ward. Each ward has only so many beds, and a full ward cannot take another patient.',
      'The Quiet Wing is an optional ward for mental health care. Some tables run it with a Psychiatrist, and some tables run without it.',
    ],
  },
  {
    id: 'theatre-icu',
    title: 'Theatre and the ICU',
    body: [
      'Operations happen in Theatre. They need a surgeon to operate and an anaesthetist to keep the patient safe.',
      'The Intensivist runs the ICU, where the sickest patients are watched closely, and also gives the anaesthetic. Their time is precious, and everyone wants it.',
    ],
  },
  {
    id: 'flow',
    title: 'How a patient moves',
    body: [
      'You can consult a specialist when you want their opinion. The patient stays with you, and you decide what to do with the advice.',
      'You can transfer a patient when another service should take over their care. The patient then belongs to that team.',
      'Scans and tests help you work out what is wrong, though results can take longer when the scanners are busy.',
    ],
  },
  {
    id: 'goals',
    title: 'Goals and limits',
    body: [
      'Your aim is to get as many patients as possible safely through the night, and to hand over a hospital in good shape at dawn.',
      'You cannot do everything. Each of you has only a few actions in a turn, so choose carefully.',
    ],
  },
];
